import { render, staticRenderFns } from "./KnowledgeGraph.vue?vue&type=template&id=3116579c&scoped=true"
import script from "./KnowledgeGraph.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraph.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeGraph.vue?vue&type=style&index=0&id=3116579c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3116579c",
  null
  
)

export default component.exports